import React from "react";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

function VideoPreviewModal({
  openPreviewVideo,
  handleClosePreviewVideo,
  videoUrl,
  customModalStyle = {},
}) {
  return (
    <Modal
      open={openPreviewVideo}
      onClose={handleClosePreviewVideo}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "65vw",
          height: "85vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          ...customModalStyle,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "black",
            padding: "10px",
          }}
        >
          <KeyboardBackspaceIcon
            style={{ color: "white", cursor: "pointer" }}
            onClick={handleClosePreviewVideo}
          />
          <CloseIcon
            style={{ color: "white", cursor: "pointer" }}
            onClick={handleClosePreviewVideo}
          />
        </div>
        <video
          src={videoUrl}
          alt="Selected"
          style={{ width: "100%", height: "100%" }}
          controls
          autoPlay
        />
      </Box>
    </Modal>
  );
}

export default VideoPreviewModal;
